import React from 'react';

import QueryTask from '@arcgis/core/tasks/QueryTask';
import Point from '@arcgis/core/geometry/Point';
import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import esriRequest from '@arcgis/core/request';
import Locate from '@arcgis/core/widgets/Locate';
import BasemapGallery from '@arcgis/core/widgets/BasemapGallery';
import Expand from '@arcgis/core/widgets/Expand';
import Graphic from "@arcgis/core/Graphic";
import Draw from "@arcgis/core/views/draw/Draw";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";

import twitter from '.././imgs/twitter_icon.png'
import whatsapp from '.././imgs/whatsappicon.png'
import email from '.././imgs/emailIcon.png'
import treePin from '../imgs/tree.png';

import DatePicker from 'react-datepicker';
import { Row, Col, Form, Button, Modal, Card } from 'react-bootstrap';

import config from './config.json';

let noneValue = "Ninguno";

export default class FormMADS extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            edades: [],
            departamentos: [],
            municipios: [],
            centrosPoblados: [],
            especies:[],
            openModal: false,
            selectedDate: new Date(),
            validated: false,
            isFormSend: false,
            showErrorSend: false,
            errorMessage: null,
            lng: "",
            lat: "",
            mpioName: "",
        }
        
        this.submitData = this.submitData.bind(this);
        this.confirmSendData = this.confirmSendData.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.changeCoordinates = this.changeCoordinates.bind(this);
    }    

    componentDidMount(){
        this.loadMap();
        this.configDDL();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevState.isFormSend && !this.state.isFormSend){
            this.loadMap();
        }
    }
    
    loadMap(){
        this.map = new Map({
            basemap: "hybrid",
            spatialReference: {wkid: 102100}
        });
    
        this.mapView = new MapView({
            map: this.map,
            container: "viewMap"
        });
    
        new Locate({
            view: this.mapView,
            container: "LocateButton"
        });
        
        let baseMapGallery = new BasemapGallery({
            view: this.mapView,             
        });
        
        var bgExpand = new Expand({
            view:  this.mapView,
            content: baseMapGallery
        });    
        
        this.mapView.ui.add(bgExpand, "top-right");
        this.mapView.when(() => {
            this.createToolbar();
        });
    }

    handleChangeDepartamento(dptoName){        
        let queryTaskMunicipio = new QueryTask({
            url: config.geoDepto
        });        
        //Municipios        
        queryTaskMunicipio.execute({
            where: `dpto='${dptoName}'`,
            outFields: ["cod_mpio", "mpio"],
            returnDistinctValues: true,
            orderByFields: ["mpio"]
        }).then(result => {            
            let municipios = result.features.map(feature => {                
                return {
                    value: feature.attributes["cod_mpio"], 
                    label: feature.attributes["mpio"]
                }
            });
            this.setState({dptoName});
            this.setState({municipios});
            this.handleChangeMunicipio(municipios[0].value);
        });
    }
    
    handleChangeMunicipio(mpioCode, mpioNombre){
            this.setState({mpioName: mpioNombre})        
            let queryTaskCP = new QueryTask({
                url: config.geoDepto
            });        
            //Centros poblados        
            queryTaskCP.execute({
                where: `cod_mpio='${mpioCode}'`,
                outFields: ["CP", "ObjectId", "Latitud", "Longitud", "dpto", "Tipo_CP", "cod_CP", "mpio"],
                returnDistinctValues: true,
                orderByFields: ["CP"]
            }).then(result => {
                //Traer la lista de centro poblado
                let centrosPoblados = result.features.map((feature, i) => {                
                    return {
                            value: feature.attributes["CP"], 
                            label: feature.attributes["CP"],
                            COD_CP: feature.attributes["cod_CP"],
                            lat: feature.attributes["Latitud"],    
                            lon: feature.attributes["Longitud"],
                            lon: feature.attributes["Longitud"],
                            mpio: feature.attributes["mpio"]                
                    }
                });                            
                this.setState({centrosPoblados});
                this.handleChangeCP(centrosPoblados[0].COD_CP);
                if(!this.state.mpioName)
                    this.setState({mpioName: centrosPoblados[0].mpio})    
                
            });        
    }

    handleChangeCP(objectid){        
        if(objectid !== noneValue ){
            let queryTaskCoords = new QueryTask({
                url: config.geoDepto
            });            
            //Latitud y logitud del centro poblado
            queryTaskCoords.execute({
                where: `cod_CP='${objectid}'`,
                outFields: ["Latitud", "Longitud"]
            }).then(result => {
                let feature = result.features?.[0];                
                if(feature){
                    let centerPoint = new Point({
                        longitude: feature.attributes["Longitud"],
                        latitude: feature.attributes["Latitud"]
                    });                    
                    this.mapView.goTo({
                        target: centerPoint, 
                        zoom: 10
                    });
                }
            });
        }
    }

    createToolbar(){        
        let draw = new Draw({
            view: this.mapView
        });

        document.getElementById("addLocation").onclick = () => {
            this.mapView.graphics.removeAll();
            const action = draw.create("point", {
                mode: "click"
            });
            this.mapView.focus();

            let srMap = new SpatialReference({wkid: this.mapView.spatialReference.wkid});

            action.on("cursor-update", (event) => {
                if (event.coordinates.length > 1) {
                    this.createPointGraphic(event.coordinates, srMap);
                }
            });

            action.on("draw-complete", (event) => {
                // create a polyline from returned vertices
                if (event.coordinates.length > 1) {
                    let point = this.createPointGraphic(event.coordinates, srMap);

                    this.setState({lng: point.longitude, lat: point.latitude});
                }
            });
        };
    }

    changeCoordinates(evt){
        evt.preventDefault();

        let _x= document.getElementById("longitud").value;
        let _y= document.getElementById("latitud").value;
        let x = parseFloat(_x);
        let y = parseFloat(_y);

        if(!isNaN(x) && !isNaN(y)){
            this.createPointGraphic([x, y], new SpatialReference({wkid: 4686}));
            this.mapView.goTo({ 
                center: [x, y]
            });
        }
    }

    createPointGraphic(coordinates, sr){
        this.mapView.graphics.removeAll();
        
        let point = new Point({
            x: coordinates[0],
            y: coordinates[1],
            spatialReference: sr
        });

        let graphic = new Graphic({
            geometry: point,
            symbol: {
                type: "picture-marker", // autocasts as SimpleMarkerSymbol
                url: treePin,
                width: "32px",
                  height: "32px",
                yoffset: "16px"
            }
        });

        this.mapView.graphics.add(graphic);
        return point;
    }

    configDDL(){
        let queryTaskDpto = new QueryTask({
            url: config.geoDepto
        });
        
        //Departamentos
        queryTaskDpto.execute({
            where: "1=1",
            outFields: ["cod_dpto", "dpto"],
            returnDistinctValues: true,
            orderByFields: ["dpto"]
        }).then(result => {
            let departamentos = result.features.map(feature => {
                return {value: feature.attributes["dpto"], label: feature.attributes["dpto"]}
            });
            this.setState({departamentos});
            this.handleChangeDepartamento(departamentos[0].value);
        });

        //Especies
        let queryTaskEspecie = new QueryTask({
            url: config.speciesService
        });        
        
        queryTaskEspecie.execute({
            where: "1=1",
            outFields: ["Nombre_Comun","FID"],
            returnDistinctValues: true,
            orderByFields: ["Nombre_Comun"]
        }).then(result => {
            let especies = result.features.map(feature => {
                return {value: feature.attributes["Nombre_Comun"], label: feature.attributes["Nombre_Comun"]}
            });
            this.setState({especies});            
        });    

        //Edad coded values
        let baseService = `${config.serviceUrl}/0?f=json`;        
        esriRequest(baseService, {
            responseType: "json"
        }).then(response => {
            response.data.fields.forEach(field => {               
                if (field["name"] === "edad"){                    
                    let domainCodes = field["domain"]["codedValues"];                    
                    let edades = domainCodes.map(domain => {                      
                        return {
                            value: domain.code, 
                            label: domain.name
                        };
                    });
                    this.setState({edades});
                }
            });
        });  
    }

    toggleModal(){
        this.setState({openModal: !this.state.openModal})
    }

    submitData(evt){
        evt.preventDefault();

        if(!evt.currentTarget.checkValidity()){
            evt.stopPropagation();
        } else{
            this.setState({openModal: true});
        }
        this.setState({
                    validated: true,
                     showErrorSend: false
        });
    }
    
    confirmSendData(){        
        this.setState({openModal: false});
    
        let serviceSurveyUrl = `${config.serviceUrl}/0`;        
        let formElement = document.getElementById("formData");
        let formData = new FormData(formElement);                
        let _file = formData.get("attachment");
        let x = parseFloat(formData.get("longitud"));
        let y = parseFloat(formData.get("latitud"));        
        let cp = formData.get("centro_poblado") === noneValue? null: formData.get("centro_poblado");
        let nombreMuni = this.state.mpioName;        
        let IDPersona = parseInt(formData.get("id_pers"));
        let cantidadArboles = parseInt(formData.get("cantidad"));
        
        let graphic = new Graphic({
            attributes:{
                sect_perso: "Persona Natural",
                orga: null,
                aliad: "Persona Natural",
                MINDATE: "2020-01-01",
                MAXDATE: "2022-08-07",
                usua: null,
                valid: "NO",
                tst: null,
                WP: null,
                noteeee: null,
                url: null,
                nomb_pers_org: formData.get("nomb_pers_org"),
                apell: formData.get("apell"),
                id_pers: IDPersona,
                edad: formData.get("rango_edad"),
                corr_pers: formData.get("email"),
                fec_siemb: this.state.selectedDate,
                esp_plant: formData.get("especie"),
                cant_arb: cantidadArboles,
                dpto: formData.get("departamento"),
                mpio: nombreMuni,
                cp: cp,
                obsrv: formData.get("observacion"),
                term: formData.get("acepto_politica")==="on"?"SI":"NO",
                term_connd: formData.get("acepto_politica")==="on"?"SI":"NO"                            
            },
            geometry: new Point({
                longitude: x,
                latitude: y,
                spatialReference: new SpatialReference({wkid: 4326})
            })
        });
        let edits = {
            "addFeatures": [graphic]
        };    
    
        //Se agregan los features y attachments    
        let layer = new FeatureLayer({
            url: serviceSurveyUrl            
        })        
                
        layer.applyEdits(edits, {            
            rollbackOnFailureEnabled: true
        }).then((results)=>{
            // console.log(results.addFeatureResults[0].error)            
            let success = true;
            let errors = [];
            
            if ("addFeatureResults" in results){
                results["addFeatureResults"].forEach((addResult)=>{
                    if (addResult.error && addResult.error){                        
                        // console.log(addResult.error)
                        errors.push(addResult.error);
                        success = false;                        
                    }
                })                
            }                    
            if (success){                
                let graphicSend = graphic;
                    graphicSend.attributes["objectid"] = results["addFeatureResults"][0].objectId;
                    graphicSend.attributes["globalid"] = results["addFeatureResults"][0].globalId;                
                //Se define los attachments en caso de que tenga    
                if(_file){                    
                    let formDataAttach = new FormData();    
                    try {
                        formDataAttach.append("attachment", _file);
                        formDataAttach.append("f", "json");        
                    } catch (error) {
                        // console.log("error formDataAttach", error)
                    }
                                    
                    layer.addAttachment(graphicSend, formDataAttach)
                        .then((result) => {
                            // console.log("addAttachment",result)
                            this.setState({isFormSend: true});
                        })
                        .catch((err) => {                        
                            this.setState({isFormSend: true});                        
                        });                    
                }
                
            } else {
                // console.log("error-NoEnvio" ,errors);
                this.setState({isFormSend: false, showErrorSend: true, errorMessage: `No se ha enviado la encuesta: <br> ${errors.join("<br>")}`});
            }
        }).catch((error)=>{
            // console.log(error)
        });    
    }

    backToSurvey(){    
        window.location.reload();
    }
    onKeyPress(event) {
        if (event.which === 13 /* Enter */) {
            event.preventDefault();
        }
    }

    render(){
        return(
            <div>
                {this.state.isFormSend
                    ?<div className="text-center mt-5">
                        <h4>Se ha guardado la encuesta, gracias por participar.</h4>
                        <Button type="button" className="btn btn-primary btn-md mt-3" onClick={()=>{this.backToSurvey()}}>Volver a llenar una encuesta</Button>
                    </div>                    
                    :<div>
                        <Form noValidate onSubmit={this.submitData} onKeyPress={this.onKeyPress} validated={this.state.validated} id="formData">
                            <div className="small-box">
                                <Row>
                                    <Col md="12">
                                        <h2 className="title">1. Persona que realiza la siembra</h2>            
                                        <h3 className="subtitle">Cuéntanos sobre tí</h3>
                                        <Row className="align-items-start">
                                            <Col md="6">
                                                <Form.Group>
                                                    <Form.Label htmlFor="nomb_pers_org">Nombres <strong>*</strong></Form.Label>
                                                    <Form.Control type="text" placeholder="Escribe tu nombre completo" id="nomb_pers_org" name="nomb_pers_org" required/>
                                                    <Form.Control.Feedback type="invalid">Ingrese su nombre</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col md="6">
                                                <Form.Group>
                                                    <Form.Label htmlFor="apell">Apellidos <strong>*</strong></Form.Label>
                                                    <Form.Control type="text" placeholder="Escribe tus dos apellidos" id="apell" name="apell" required />
                                                    <Form.Control.Feedback type="invalid">Ingrese su apellido</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="align-items-start mt-2">
                                            <Col md="4">
                                                <Form.Group>
                                                    <Form.Label htmlFor="id_pers">Identificación <strong>*</strong></Form.Label>
                                                    <Form.Control type="number" placeholder="Escribe solo números" id="id_pers" name="id_pers" max="2147483647" required />
                                                    <Form.Control.Feedback type="invalid">Identificación inválida</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col md="2">
                                                <Form.Group>
                                                    <Form.Label htmlFor="rango_edad">Rango de edad</Form.Label>
                                                    <Form.Select name="rango_edad">
                                                        {
                                                            this.state.edades.map((edad, key) => {
                                                                return (<option key={key} value={edad.value}>{edad.label}</option>)
                                                            })
                                                        }
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md="6">
                                                <Form.Group>
                                                    <Form.Label htmlFor="email">Correo electrónico <strong>*</strong></Form.Label>
                                                    <Form.Control type="email" placeholder="Escribe tu correo electrónico" id="email" name="email" required />
                                                    <Form.Control.Feedback type="invalid">Ingrese un correo válido</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div className="small-box">
                                <Row>
                                    <Col md="12">
                                        <h2 className="title">2. Detalles de la siembra</h2>                                    
                                        <Row className="align-items-start">
                                            <Col md="6">
                                                <h3 className="subtitle">Cuándo sembraste?</h3>
                                                <Row className="align-items-start">
                                                    <Col md="12">
                                                        <Form.Label htmlFor="fecha_siembra">Fecha de realización de la siembra *</Form.Label>
                                                        <DatePicker id="fecha_siembra" name="fecha_siembra" className="form-control input input-append date" placeholder="Elija el día de inicio de la siembra" dateFormat="dd/MM/yyyy" minDate={(new Date("08/07/2018"))} selected={this.state.selectedDate} onChange={(selectedDate) => this.setState({selectedDate})} />                                                
                                                    </Col>
                                                </Row>                                        
                                            </Col>
                                            <Col md="6">
                                                <h3 className="subtitle">Qué sembraste?</h3>
                                                <Row className="align-items-start">
                                                    <Col md="6">
                                                        <Form.Group>
                                                            <Form.Label htmlFor="especie">Especie sembrada *</Form.Label>                                    
                                                            <Form.Select name="especie">
                                                                {
                                                                    this.state.especies.map((e, key) => {
                                                                        return (<option key={key} value={e.value}>{e.label}</option>)
                                                                    })
                                                                }
                                                            </Form.Select>                                                    
                                                            {/* <Autocomplete id="especie" table={config.speciesService} fieldName="Nombre_Comun" placeholder="Elija una especie" > */}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md="6">
                                                        <Form.Group>
                                                            <Form.Label htmlFor="cantidad">Cantidad *</Form.Label>
                                                            <Form.Control type="number" placeholder="Número de árboles" name="cantidad" min="0" step="1" required />
                                                            <Form.Control.Feedback type="invalid">Ingrese una cantidad correcta de árboles</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>                                            
                                                </Row>                                    
                                            </Col>
                                            <Col md="12" className="mt-3">
                                                <h3 className="subtitle">Dónde Sembraste?</h3>
                                                <Row className="align-items-start">
                                                    <Col md="2">
                                                        <Form.Group>
                                                            <Form.Label htmlFor="departamento">Departamento *</Form.Label>
                                                            <Form.Select name="departamento" placeholder="Elija uno" onChange={(evt)=>{this.handleChangeDepartamento(evt.currentTarget.value)}}>
                                                                {
                                                                    this.state.departamentos.map((dpto, key) => {
                                                                        return (<option key={key} value={dpto.value}>{dpto.label}</option>)
                                                                    })
                                                                }
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md="4">
                                                        <Form.Group>
                                                            <Form.Label htmlFor="municipio">Municipio *</Form.Label>
                                                            <Form.Select name="municipio" placeholder="Elija uno" onChange={(evt)=>{this.handleChangeMunicipio(evt.currentTarget.value, evt.currentTarget.options[evt.currentTarget.selectedIndex].text)}}>
                                                                {
                                                                    this.state.municipios.map((mnpio, key) => {
                                                                        return (<option key={key} value={mnpio.value}>{mnpio.label}</option>)
                                                                    })
                                                                }                                                    
                                                            </Form.Select>
                                                        </Form.Group>                                                
                                                    </Col>
                                                    <Col md="6">
                                                        <Form.Group>
                                                            <Form.Label htmlFor="centro_poblado">Centros poblados más cercanos</Form.Label>
                                                            <Form.Select name="centro_poblado" placeholder="Elija uno" onChange={(evt)=>{this.handleChangeCP(evt.currentTarget.value)}}>
                                                                <option>{noneValue}</option>
                                                                {
                                                                    this.state.centrosPoblados.map((cp, key) => {
                                                                        return (<option key={key} value={cp.label}>{cp.label}</option>)
                                                                    })
                                                                }                                                    
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row className="align-items-start">
                                            <div className="contentMap">
                                                <div id="viewMap" className="map"></div>
                                                <div id="BaseMapButton"></div>
                                                <div id="btnDiv">
                                                    <div id="LocateButton"></div>
                                                    <Button type="button" className="btn btn-primary" id="addLocation" name="addLocation"><i className="bi bi-dot"></i>Agregar Ubicación</Button> 
                                                </div>                                        
                                            </div>
                                        </Row>
                                        <Row className="align-items-start" style={{marginTop: "10px"}}>
                                            <Col md="6">
                                                <Form.Group>
                                                    <Form.Label htmlFor="longitud">Longitud *</Form.Label>
                                                    <Form.Control type="text" id="longitud" name="longitud" value={this.state.lng} required onChange={(evt)=>{this.setState({lng: evt.currentTarget.value})}}/>
                                                    <Form.Control.Feedback type="invalid">Ingrese la longitud</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col md="6">
                                                <Form.Group>
                                                    <Form.Label htmlFor="latitud">Latitud *</Form.Label>
                                                    <Form.Control type="text" id="latitud" name="latitud" value={this.state.lat} required onChange={(evt)=>{this.setState({lat: evt.currentTarget.value})}}/>
                                                    <Form.Control.Feedback type="invalid">Ingrese la latitud</Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="justify-content-md-center" style={{marginTop: "10px"}}>
                                            <Col md="auto">
                                                <Button type="button" className="btn btn-primary" onClick={this.changeCoordinates}>Actualizar coordenadas</Button>                     
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div className="small-box">
                                <Row>
                                    <Col md="12">
                                        <div className="well minisection">
                                            <h2 className="title">3. Evidencia de la siembra</h2>            
                                            <h4 className="subtitle">Imagen de tu árbol o de la siembra</h4>
                                            <Row className="align-items-start">
                                                <Col md="12">
                                                    <Form.Group>
                                                        <Form.Label htmlFor="attachment">Carga un archivo desde tu dispositivo</Form.Label>
                                                        <Form.Control className="form-control" type="file" id="attachment" name="attachment"/>
                                                    </Form.Group>
                                                </Col>                        
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="small-box">
                                <Row>
                                    <Col md="12">
                                        <h2 className="title">4. Comentarios sobre la siembra</h2>            
                                        <h4 className="subtitle">Agrega cualquier información adicional</h4>
                                        <h4 className="subtitle-2">Máximo 255 caracteres</h4>
                                        <Row className="align-items-start">
                                            <Col md="12">
                                                <Form.Group>
                                                    <Form.Control as="textarea" id="observacion" name="observacion" rows="4" maxLength="255" placeholder="Deja aquí tus notas o comentarios adicionales"/>
                                                </Form.Group>             
                                            </Col>                        
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div className="small-box">
                                <Row>
                                    <h2 className="title">5. Cuéntales a todos sobre tu legado</h2>   
                                    <h4 className="subtitle">Qué quieres hacer?</h4> 
                                    <Row md="align-items-center">
                                        <Col sm="12" md="4" lg="4">
                                            <a href="https://twitter.com/intent/tweet?text= He participado en el gran sembratón nacional del 2020. @MinAmbienteCo" rel="noreferrer" target="_blank">
                                                <Card style={{width: "16rem", minHeight:"112px"}}>
                                                    <Card.Body>
                                                        <div className="img-container">
                                                            <img src={twitter} className="img-fluid" alt="Twitter" loading="lazy"/>
                                                        </div>
                                                        {/* <b>Participar y conversar</b> */}
                                                        <p className="text-info">#SembrarNosUne</p>                                                
                                                    </Card.Body>
                                                </Card>
                                            </a>
                                        </Col>
                                        <Col sm="12" md="4" lg="4">                                            
                                            <a href={encodeURI("https://api.whatsapp.com/send?text=He participado en la gran sembratón nacional 2020, únete en el siguiente link: https://arcg.is/5GaW9")} rel="noreferrer" target="_blank">
                                                <Card style={{width: "16rem", minHeight:"112px"}}>
                                                    <Card.Body>
                                                        <div className="img-container">
                                                            <img src={whatsapp} className="img-fluid" alt="Whatsapp" loading="lazy"/>
                                                        </div>
                                                        <b>Compartirlo al instante</b>
                                                        {/* <p className="text-info">A tus amigos</p>                                         */}
                                                    </Card.Body>
                                                </Card>
                                            </a>
                                        </Col>
                                        <Col sm="12" md="4" lg="4">
                                            <a href="mailto:sembrarnosune@minambiente.gov.co" rel="noreferrer" target="_blank">
                                                <Card style={{width: "16rem", minHeight:"112px"}}>
                                                    <Card.Body>
                                                        <div className="img-container">
                                                            <img src={email} className="img-fluid" alt="Email" loading="lazy"/>
                                                        </div>
                                                        <b>Escribir un correo</b>
                                                        {/* <p className="text-info">Contáctanos</p> */}
                                                    </Card.Body>
                                                </Card>
                                            </a>
                                        </Col>
                                    </Row>
                                </Row>
                            </div>
                            <div className="small-box">
                                <Row>
                                    <h2 className="title">6. Tu privacidad y manejo de datos</h2>
                                    <Row className="align">
                                        <Col md="12">
                                            <Form.Group>
                                                <Form.Check type="checkbox" id="acepto_politica" name="acepto_politica"
                                                    label={
                                                        <>
                                                            <h5 className="subtitle">Acepto la <a href="https://www.minambiente.gov.co/images/Atencion_y_particpacion_al_ciudadano/proteccion_datos_personales/Pol%C3%ADtica_de_Protecci%C3%B3n_de_Datos_Personales.pdf" rel="noreferrer" target="_blank">Política de Privacidad</a></h5>
                                                            <p>Y me declaro responsable de la veracidad de estos datos que podrán ser verificados y validados por el MinAmbiente.</p>
                                                        </>
                                                    }
                                                />    
                                            </Form.Group>
                                        </Col>                                
                                    </Row>  
                                    
                                </Row>
                            </div>
                            <Row className="no-gutters align-items-center mt-3">
                                <div className="text-center">
                                    <Button type="submit" className="abrir btn btn-primary btn-lg" id="btnEnviar">Enviar</Button>
                                </div>
                            </Row>
                            {
                                //Mostrar mensaje de error en caso de que haya alguno
                                this.state.showErrorSend &&
                                <Row className="text-center">
                                    <div className="alert alert-danger mt-2" role="alert">
                                        {this.state.errorMessage}
                                    </div>
                                </Row>
                            }
                        </Form>

                        <Modal show={this.state.openModal} onHide={this.toggleModal} id="modalConfirm" labelledby="exampleModalLabel">
                            <Modal.Header closeButton>Enviar</Modal.Header>
                            <Modal.Body>
                                Enviar encuesta y finalizar
                            </Modal.Body>
                            <Modal.Footer>
                                <Button color="primary" onClick={ this.confirmSendData }>Enviar</Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                }
            </div>
        )
    }
}